// extracted by mini-css-extract-plugin
module.exports = {"close":"aee5b7c44e--close--PwRYk","content":"aee5b7c44e--content--v0E5y","img":"aee5b7c44e--img--g8Unn","link":"aee5b7c44e--link--t1j73"};